import { render } from "./MarketingItem.vue?vue&type=template&id=599218b4&scoped=true"
import script from "./MarketingItem.vue?vue&type=script&lang=js"
export * from "./MarketingItem.vue?vue&type=script&lang=js"

import "./MarketingItem.vue?vue&type=style&index=0&id=599218b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599218b4"]])

export default __exports__